export function toCamelCase(string) {
  return string
    .replace(/[^a-zA-Z0-9]+(.)?/g, (_, character) => character ? character.toUpperCase() : '')
    .replace(/^./, match => match.toLowerCase());
}

const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

export function toPx(value, options = {}) {
  const {
    includeUnit = true,
    root = rootFontSize,
  } = options;
  const result = parseFloat(value) * root;

  return includeUnit ? `${result}px` : result;
}

export function toRem(value, options = {}) {
  const {
    includeUnit = true,
    root = rootFontSize,
  } = options;
  const result = parseFloat(value) / root;

  return includeUnit ? `${result}rem` : result;
}

export function toSlug(value, options = {}) {
  const {
    separator = '-',
  } = options;

  if (!value) return '';

  return value
    .toLowerCase().trim()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, ' ').trim()
    .replace(/[\s-]+/g, separator);
}

